import React from 'react'

export default function Container({ children }) {
  return (
    <div className="pcoded-main-container">
      <div className="pcoded-content">{children}</div>
    </div>
  )
}
